import { colors, gradients } from '@airwallex/global';
var navTheme = {
  background: colors.greys[100],
  item: {
    color: colors.greys[30],
    hover: {
      color: colors.white
    },
    selected: {
      gradient: "orange"
    },
    tag: {
      background: "rgba(255, 255, 255, .15)",
      color: colors.white,
      selected: {
        background: gradients.orange,
        color: colors.white
      }
    }
  },
  button: {
    hover: {
      background: colors.greys[90]
    }
  },
  subMenuLine: colors.greys[80],
  tooltip: {
    background: colors.greys[70]
  }
};
export { navTheme };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzIjpbXSwic291cmNlc0NvbnRlbnQiOltdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiIn0=
